import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";
import React from "react";
import styles from "./styles.module.scss";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import USGAScoreCardTable from "../USGAScoreCardTable";

const ScoreCardModal = ({ isModalOpen, modalHandler, score }) => {
  const { t } = useTranslation();

  return (
    <ModalLayout
      isOpen={isModalOpen}
      onClose={modalHandler}
      wrapperClassName={styles.modal_layout_wrapper}
    >
      <div className={styles.content_wrapper}>
        <div className={styles.header}>
          <div className={styles.back_button} onClick={modalHandler}>
            <i className="ico ico-back" />
          </div>
          <div className={styles.score_info}>
            <p className={styles.course_name}>{score.courseDisplayValue}</p>
            <span className={styles.subtitle}>
              {`${score.courseRating.toFixed(1)} / ${score.slopeRating} • ${t(
                'Differential: {{differential}}',
                { differential: score.differential.toFixed(1) }
              )}`}
            </span>
            <span className={styles.subtitle}>
              {DateTime.fromISO(score.playedAt).toFormat("MMM d, yyyy")}
            </span>
          </div>
        </div>
        <USGAScoreCardTable
          holesData={score.holeDetails}
          hasAdvancedStats={score.hasAdvancedStats}
        />
      </div>
    </ModalLayout>
  );
};

export default ScoreCardModal;
